import React, {Component} from 'react';
import {observer,inject} from "mobx-react";
import Loading from "./Loading";
import Section from "./Section";
import {StoreContext} from "../stores/contexts";

class SectionSearchResult extends Component {
  static contextType = StoreContext;

  renderResult() {
    if(this.context.searchStore.result.inited) {
      if(this.context.searchStore.result.fetching) {
        return (
          <Loading />
        )
      } else {
        const list=this.context.searchStore.result.data.map((item)=>{
          return (
            <Section level={1} item={item} key={item.id} search={true} />
          )
        });
        return (
          <div className="ptop20">
            {list}
          </div>
        )
      }
    }
  }
  render() {
    return (
      <div>
        {this.renderResult()}
      </div>
    )
  }
}

// export default inject("treeStore","searchStore")(observer(SectionSearchResult));
export default observer(SectionSearchResult);